<template>
<div class="about-area">
    <div class="container">
        <!-- Trending Tittle -->
        <div class="row">
            <div class="col-lg-12">
                <div class="trending-tittle"></div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-8">
                <!-- Trending Tittle -->
                <div class="about-right mb-90">
                    <div class="section-tittle mb-30 pt-30">
                        <h3 style="text-align: center;">TÍNH ƯU VIỆT CỦA HÌNH THỨC ĐẤU GIÁ TRỰC TUYẾN</h3>
                    </div>
                    <div class="about-prea" style="text-align: justify;">
                        <p class="about-pera1">
                            Luật đấu giá tài sản năm 2016 được Quốc hội Khóa XIV thông qua ngày 17/11/2016 đã đánh dấu mốc quan trọng chính thức công nhận “đấu giá trực tuyến” là một trong những hình thức đấu giá được pháp luật bảo hộ bên
                            cạnh những hình thức đấu giá truyền thống. Chính phủ cũng đưa ra những quy định chi tiết về hình thức đấu giá trực tuyến tại Nghị định 62/2017/NĐ-CP. Hình thức đấu giá trực tuyến được kỳ vọng sẽ mang lại một thị
                            trường kinh doanh minh bạch và cạnh tranh lành mạnh với nhiều tính ưu việt so với các hình thức đấu giá truyền thống:
                        </p>
                        <p class="about-pera1">
                            Thứ nhất, đấu giá trực tuyến không có giới hạn về thời gian, không gian và vị trí địa lý, Người có nhu cầu mua tài sản có thể tiếp cận thông tin về tài sản, đăng ký và tham gia đấu giá từ bất cứ nơi nào trên thế
                            giới mà chỉ cần có máy tính, điện thoại thông minh kết nối Internet, do đó sẽ thu hút được nhiều người có tài sản và nhiều người tham gia đấu giá, tạo nên một thị trường mua bán sản phẩm sôi động, đa dạng và đóng
                            góp nhiều lợi ích tích cực cho ngân sách nhà nước từ nguồn thu thuế, và mang lại nhiều giá trị văn minh cho xã hội.
                        </p>
                        <p class="about-pera1">
                            Thứ hai, đấu giá trực tuyến sẽ tạo nên một thị trường mua bán công khai, minh bạch những vẫn đảm bảo bảo mật thông tin khách hàng do đó sẽ không có hiện tượng cấu kết, thông đồng, dìm giá. Giá trị hàng hóa sẽ
                            được quyết định theo sát giá thị trường, mang lại lợi ích tối đa cho người có tài sản và đồng thời sẽ bảo vệ được người tham gia đấu giá trách khỏi những phiền phức, thậm chí đe dọa hay cưỡng ép từ những người
                            tham gia đấu giá khác có ý đồ không tốt.
                        </p>
                        <p class="about-pera1">
                            Thứ ba, đấu giá trực tuyến tiết kiệm được thời gian, chi phí tổ chức đấu giá. Khác với các hình thức đấu giá truyền thống, tại một thời điểm, đấu giá viên chỉ có thể điều hành 01 cuộc đấu giá, và người tham gia
                            đấu giá cũng chỉ có thể tham gia 01 cuộc đấu giá tại một địa điểm nhất định; Và để tổ chức một cuộc đấu giá cần có 01 Đấu giá viên và nhiều nhân viên giúp việc. Đối với đấu giá trực tuyến, tại một thời điểm Đấu
                            giá viên có thể điều hành nhiều cuộc đấu giá chỉ cần 01 nhân viên kỹ thuật hỗ trợ; người tham gia đấu giá cũng có thể tham gia nhiều cuộc đấu giá một lúc.
                        </p>
                        <p class="about-pera1">
                            Hiện nay, với sự phát triển mạnh mẽ của công nghệ thông tin cùng xu hướng toàn cầu hóa, việc phát triển hình thức đấu giá trực tuyến sẽ mở ra một trang mới, hướng tới những cuộc đấu giá không bị giới hạn về thời
                            gian, không gian và vị trí địa lý, đưa hoạt động đấu giá tài sản tiến tới hướng chuyên nghiệp, đi vào cuộc sống, phù hợp với bối cảnh đất nước đang coi trọng phát triển ứng dụng công nghệ thông tin, góp phần
                            hướng tới xây dựng Chính phủ điện tử và nền kinh tế số ở Việt Nam.
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4"></div>
        </div>
    </div>
</div>

</template>

<script>
import mixin from '@/mixins/mixin.js'
export default {
  name: 'About',
  mixins: [mixin],
  data () {
    return {
    }
  },
  methods: {
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/News/1.vue